import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Instagram, X } from 'lucide-react';

export function Footer() {
  return (
    <footer className="relative text-white overflow-hidden">
      {/* Background image */}
      <div aria-hidden className="absolute inset-0 z-0 bg-cover bg-center" style={{ backgroundImage: "url('/hero1-bg.jpg')" }}></div>
      {/* Dark overlay */}
      <div aria-hidden className="absolute inset-0 z-[5] bg-black/70"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <span className="text-xl font-bold">İLİMERA Teknoloji Yazılım</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Yenilikçi elektronik ve yazılım çözümleri ile teknoloji dünyasında 
              güvenilir çözümler sunuyoruz. Müşteri odaklı yaklaşımımızla sektörde 
              öncü olmaya devam ediyoruz.
            </p>
            <div className="space-y-2">
              <div className="flex items-start text-gray-300">
                <MapPin size={16} className="mr-2 mt-1" />
                <span>
                  <strong>Genel Merkez</strong>
                  <br />
                  Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96  
                  <br />
                  Konyaaltı / ANTALYA
                </span>
              </div>
              <div className="flex items-center text-gray-300">
                <MapPin size={16} className="mr-2" />
                <span>
                  <strong>Ar-Ge Merkezi</strong>
                  <br />
                  Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1
                  <br />
                  Merkez / ISPARTA
                </span>
              </div>
              <div className="flex items-center text-gray-300">
                <Phone size={16} className="mr-2" />
                <span>+90 (542) 549 85 27</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Mail size={16} className="mr-2" />
                <span>info@ilimera.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-gray-300 hover:text-white transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/urunler" className="text-gray-300 hover:text-white transition-colors">
                  Ürünlerimiz
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-300 hover:text-white transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-semibold mb-4">Sosyal Medya</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/i%CC%87li%CC%87mera/" 
                target="_blank"
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://www.instagram.com/ilimera_teknoloji/" 
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © 2024 İLİMERA Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/cerez-politikasi" className="text-gray-300 hover:text-white text-sm transition-colors">
                Gizlilik ve Çerez Politikası
              </Link>
              <Link to="/kvkk-iletisim-aydinlatma" className="text-gray-300 hover:text-white text-sm transition-colors">
                KVKK Aydınlatma Metni
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}